import { useBoolean, useIsMobile } from '@sravni/react-utils';

import type { FILTERS_NAMES } from '@src/constants/filters';
import { TO_FULL_DEAL_BUTTON_DEFAULT_TEXT } from 'entities/FullDeal/config';
import { useMicrocreditDeals } from 'entities/FullDeal/lib';

import { useOnChangeCalculator } from './useOnChangeCalculator';

export const useCalculator = (onChange: (key: FILTERS_NAMES, value: number) => void) => {
  const isMobile = useIsMobile();
  const [isInfoShown, setIsInfoShown] = useBoolean();

  const { hasForm, hasOffer, isOfferWaiting, toFullDealButtonText, hasIssuedMicrocreditDeals } = useMicrocreditDeals();

  const { amount, term, handleChange } = useOnChangeCalculator({ onChange });

  // @todo: показываем калькулятор если нет активного офера и шаг не ожидание оффера
  const isShowCalculator = !hasOffer && !isOfferWaiting;
  const hasOfferOrForm = hasOffer || hasForm || isOfferWaiting;
  const _toFullDealButtonText = toFullDealButtonText || TO_FULL_DEAL_BUTTON_DEFAULT_TEXT;

  return {
    amount,
    term,
    handleChange,
    isShowCalculator,
    isMobile,
    isInfoShown,
    setIsInfoShown,
    _toFullDealButtonText,
    hasOffer,
    hasIssuedMicrocreditDeals,
    hasOfferOrForm,
    toFullDealButtonText,
  };
};
